/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBarStacked100V = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-chart-bar-stacked-100-v_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-chart-bar-stacked-100-v_svg__st0"
      d="M20 20v-6h-2v6h-2v-9h-2v9h-2v-5h-2v5H8v-7H6v7H4V2H2v20h20v-2z"
    />
    <path
      className="ico-chart-bar-stacked-100-v_svg__st0"
      d="M6 8h2v4H6zm0-6h2v5H6zm8 0h2v8h-2zm-4 0h2v12h-2zm8 0h2v2h-2zm0 3h2v8h-2z"
    />
  </Icon>
);
export { SvgChartBarStacked100V as ChartBarStacked100V };
